import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Check, X, Loader2 } from "lucide-react";

export function PaymentSuccessPage() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { refresh } = useAuth();
  const [status, setStatus] = useState("pending");

  useEffect(() => {
    if (!sessionId) return;
    let tries = 0; let timer;
    const poll = async () => {
      tries++;
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") { setStatus("paid"); await refresh(); return; }
        if (["failed", "expired"].includes(r.data.payment_status)) { setStatus(r.data.payment_status); return; }
      } catch { /* ignore */ }
      if (tries < 30) timer = setTimeout(poll, 2000); else setStatus("timeout");
    };
    poll();
    return () => timer && clearTimeout(timer);
  }, [sessionId]);  // eslint-disable-line

  return (
    <div className="min-h-screen flex items-center justify-center px-6 jx-grid-bg">
      <div className="jx-glass rounded-3xl p-6 max-w-md w-full text-center">
        {status === "pending" && <><Loader2 className="mx-auto animate-spin text-cyan-300" size={40} /><h1 className="mt-3 font-heading text-2xl font-bold">Confirming payment…</h1></>}
        {status === "paid" && <><Check className="mx-auto text-emerald-400" size={40} /><h1 className="mt-3 font-heading text-2xl font-bold">Payment confirmed</h1><p className="text-slate-400 mt-1">Coins credited. Elite features unlocked.</p></>}
        {(status === "failed" || status === "expired" || status === "timeout") && <><X className="mx-auto text-rose-400" size={40} /><h1 className="mt-3 font-heading text-2xl font-bold">Something went wrong</h1><p className="text-slate-400 mt-1 capitalize">{status}</p></>}
        <Link to="/scan" data-testid="payment-back-scan" className="mt-4 inline-flex h-11 px-5 rounded-xl bg-cyan-400 text-slate-950 font-semibold items-center active:scale-95">Back to scanner</Link>
      </div>
    </div>
  );
}

export function PaymentCancelPage() {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 jx-grid-bg">
      <div className="jx-glass rounded-3xl p-6 max-w-md w-full text-center">
        <X className="mx-auto text-slate-400" size={40} />
        <h1 className="mt-3 font-heading text-2xl font-bold">Checkout cancelled</h1>
        <p className="text-slate-400 mt-1">No charges were made.</p>
        <Link to="/coins" data-testid="payment-back-shop" className="mt-4 inline-flex h-11 px-5 rounded-xl bg-cyan-400 text-slate-950 font-semibold items-center active:scale-95">Back to Coin Shop</Link>
      </div>
    </div>
  );
}
